"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetGroupedProduct = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _useProducts = require("../../hooks/internal/useProducts");
var _utils = require("../../utils");
var _getProductInfoDialogProducts = require("../getProductInfoDialogProducts");
// istanbul ignore file @preserve -- api

const useGetGroupedProduct = currentProductCode => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    headers
  } = (0, _presentationHttp.useHeaders)();
  const logger = (0, _logger.useLogger)('useGetGroupedProduct');
  const {
    setProducts
  } = (0, _useProducts.useProducts)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const [groupedProductCode, setGroupedProductCode] = (0, _react.useState)(null);
  const onGroupedProductCodeClick = (0, _react.useCallback)(productCode => {
    setGroupedProductCode(productCode);
  }, []);
  const {
    data: fetchedGroupedProduct
  } = (0, _fetching.useSWR)(groupedProductCode, async code => {
    setLoading(true);
    const [product] = await (0, _getProductInfoDialogProducts.getProductInfoDialogProducts)({
      customerTypeId,
      graphQlUrl: graphQlNetUrl,
      productCodes: [code],
      headers
    });
    return product;
  }, {
    ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
    onError: error => logger.error(new Error('Error fetching grouped product', {
      cause: error
    }))
  });
  (0, _react.useEffect)(() => {
    if (fetchedGroupedProduct) {
      setProducts((0, _utils.replaceProduct)({
        currentProductCode,
        fetchedGroupedProduct
      }));
    }
    setLoading(false);
  }, [currentProductCode, fetchedGroupedProduct, setProducts]);
  return {
    loading,
    onGroupedProductCodeClick
  };
};
exports.useGetGroupedProduct = useGetGroupedProduct;
